import * as React from 'react';
import Zoom from '@mui/material/Zoom';
import { useTheme } from 'styled-components';
import { InfoIcon } from 'src/assets/icons';
import { StyledWrapper, StyledTooltip } from './InfoTooltip.styled';

interface InfoTooltipProps {
  title: React.ReactNode;
  className?: string;
}

export const InfoTooltip: React.FunctionComponent<InfoTooltipProps> = ({ title, className = '' }) => {
  const theme = useTheme();
  return (
    <StyledTooltip
      title={title}
      $scTheme={theme}
      placement="top"
      arrow
      slots={{
        transition: Zoom,
      }}
    >
      <StyledWrapper className={className}>
        <InfoIcon />
      </StyledWrapper>
    </StyledTooltip>
  );
};
